export default {
  设备分析: 'Device Analysis',
  请选择代理商: 'Please select an agent',
  请选择场地: 'Please select a site',
  总设备数: 'Total number of devices',
  已激活设备: 'Total number of activated devices',
  使用中设备: 'Total number of active devices',
  单台设备收益: 'Single device income',
  子设备数: 'Number of sub-devices',
  在线设备数: 'Number of online devices',
  故障处理率: 'Fault handling rate',
  总设备量: 'Total number of devices',
  子设备数: 'Number of sub-devices',
  故障处理率: 'Fault handling rate',
  故障类型: 'Fault type',
  设备总营业额: 'Total device turnover',
  次: 'count',
  新增设备: 'New devices',
  个: 'number',
  小程序卡: 'Mini program card',
  元: '$',
  设备排名: 'Device ranking',
  总消费: 'Total consumption',
  客单价: 'Average price',
  订单量: 'Order quantity',
  排名: 'ranking',
  设备名称: 'Device name',
  代理商: 'Agent',
  总营业额: 'Total turnover',
  财务分析: 'Financial analysis',
  总流水: 'Total flow',
  日平均收益: 'Average income per day',
  月平均收益: 'Average income per month',
  今日收益: "Today's income",
  本月收益: "This month's income",
  订单数: 'Number of orders',
  平均客单价: 'Average price per order',
  流水GMV: 'Flow GMV',
  总收益TR: 'Total income TR',
  退款金额: 'Refund amount',
  代理商排名: 'Agent ranking',
  场地排名: 'Site ranking',
  总收益: 'Total income',
  场地数: 'Number of sites',
  设备数: 'Number of devices',
  总营收: 'Total revenue',
  代理商级别: 'Agent level',
  名称: 'Name',
  场地名称: 'Site name',
  场地负责人: 'Site manager',
  电量度数: 'Electricity level',
  服务费: 'Service fee',
  导出: 'Export',
  用户行为: 'User behavior',
  总注册数: 'Total number of registrations',
  日活用户数: 'Daily active users',
  月活用户数: 'Monthly active users',
  今日注册: "Today's registration",
  本月注册: "This month's registration",
  人均订单数: 'Average number of orders per user',
  人均分享数: 'Average number of shares per user',
  场地浏览量: 'Site view count',
  总收藏数: 'Total number of favorites',
  设备反馈: 'Device feedback',
  订单反馈: 'Order feedback',
  总评价数: 'Total number of evaluations',
  分享次数: 'Number of shares',
  分享查看次数: 'Number of share views',
  用户类型: 'User type',
  用户状态: 'User status',
  用户营收占比: 'User revenue ratio',
  用户注册: 'User registration',
  充电趋势: 'Charging trend',
  近一周: 'Last week',
  近一月: 'Last month',
  用户ID: 'User ID',
  用户名: 'Username',
  充电电量: 'Charging power',
  场站运营: 'Station operation',
  今日充电: "Today's charging",
  充电次数: 'Charging count',
  订单实收金额: 'Actual order amount',
  电费实收: 'Electricity bill',
  服务费实收: 'Service fee',
  环比增长: 'Growth rate',
  运营商收入占比: 'Operator income ratio',
  营收占比: 'Revenue ratio',
  投运终端状态: 'Installation terminal status',
  营收趋势: 'Revenue trend',
  近一年: 'Last year',
  直流: 'DC',
  交流: 'AC',
  交流桩占比: 'AC plug ratio',
  工作台: 'Workbench',
  总场地数: 'Total site number',
  申请中场地: 'Pending site',
  停用场地数: 'Disabled site number',
  运营中场地: 'Operating site',
  总订单数: 'Total order number',
  营业额: 'Turnover',
  激活设备数: 'Activated device number',
  总激活设备数: 'Total activated device number',
  停用中设备数: 'Disabled device number',
  空闲中设备数: 'Idle device number',
  故障率: 'Fault rate',
  总用户数: 'Total user number',
  一级代理用户: 'Level 1 agent user',
  二级代理用户: 'Level 2 agent user',
  三级代理用户: 'Level 3 agent user',
  维护人员数: 'Maintenance personnel number',
  平台用户数: 'Platform user number',
  场地方用户数: 'Site user number',
  待处理事项: 'Pending items',
  提现申请: 'Withdrawal application',
  场地申请: 'Site application',
  招商申请: 'Business application',
  意见反馈: 'Feedback',
  工单申请: 'Work order',
  设备报警: 'Device alarm',
  消息通知: 'Message notification',
  暂无消息通知: 'No message notification',
  充电热度: 'Charging heat',
  充电量曲线: 'Charging curve',
  问题占比: 'Problem ratio',
  昵称: 'Nickname',
  手机号: 'Phone number',
  认证状态: 'Verification status',
  日期范围: 'Date range',
  请输入: 'Please enter',
  头像: 'Avatar',
  手机号: 'Phone number',
  最后登录时间: 'Last login time',
  注册时间: 'Registration time',
  钱包总余额: 'Total wallet balance',
  总电量: 'Total power',
  总消费金额: 'Total consumption amount',
  总卡包余额: 'Total card balance',
  状态: 'Status',
  启用: 'Enabled',
  禁用: 'Disabled',
  正常: 'Normal',
  详情: 'Details',
  查询: 'Query',
  重置: 'Reset',
  用户总数: 'Total user number',
  禁用用户总数: 'Total disabled user number',
  操作人: 'Operator',
  订单: 'Order',
  用户流水: 'User flow',
  优惠券: 'Coupon',
  优惠券总数: 'Total number of coupons',
  充值: 'Recharge',
  用户充值: 'User recharge',
  请选择用户: 'Please select user',
  支付: 'Pay',
  '确认后扫描付款码支付，金额将充值到用户账户中': 'After confirmation, scan the payment code to pay, and the amount will be Recharge to the user account',
  提现: 'Withdrawal',
  评价: 'Evaluation',
  意见: 'Opinion',
  IC卡: 'IC card',
  车辆信息: 'Vehicle information',
  钱包余额: 'Wallet balance',
  卡包余额: 'Card balance',
  总充值: 'Total recharge',
  待退款: 'Pending refund',
  总退款: 'Total refund',
  返回: 'Back',
  序号: 'Serial number',
  企业名称: 'Enterprise name',
  企业身份: 'Enterprise identity',
  运营商: 'Operator',
  运营商属性: 'Operator attribute',
  添加: 'Add',
  企业总数: 'Total enterprise number',
  场地总数: 'Total site number',
  设备总数: 'Total device number',
  已提现余额: 'Withdrawn balance',
  统一社会信用代码: 'Uniform social credit code',
  登录账号: 'Login account',
  上级企业: 'Upper-level enterprise',
  开户银行卡号: 'Bank account number',
  开户状态: 'Account opening status',
  失败原因: 'Failure reason',
  历史总金额: 'Historical total amount',
  历史总收益: 'Historical total income',
  场地数量: 'Site number',
  设备数量: 'Device number',
  操作: 'Operation',
  编辑: 'Edit',
  禁用: 'Disable',
  开户信息编辑: 'Account opening information edit',
  可用余额明细: 'Available balance details',
  在途余额明细: 'In-transit balance details',
  下级操作人: 'Lower-level operator',
  场地: 'Site',
  设备: 'Device',
  日志: 'Log',
  邮箱: 'Email',
  上级代理: 'Upper-level agent',
  重置登录密码: 'Reset login password',
  登录密码: 'Login password',
  确认密码: 'Confirm password',
  提交: 'Submit',
  重置提现密码: 'Reset withdrawal password',
  验证码: 'Verification code',
  发送验证码: 'Send verification code',
  提现密码: 'Withdrawal password',
  可分配余额: 'Available balance',
  开户客户号: 'Account opening customer number',
  宝付登录号: 'Baofoo login number',
  场地方数量: 'Site number',
  订单数量: 'Order number',
  '历史总收益/元': 'Historical total income/$',
  交易类型: 'Transaction type',
  余额方向: 'Balance direction',
  币种: 'Currency',
  交易金额: 'Transaction amount',
  交易后余额: 'Balance after transaction',
  创建时间: 'Create time',
  宝付订单号: 'Baofoo order number',
  商户订单号: 'Merchant order number',
  明细类型: 'Detail type',
  账簿可用余额: 'Account book available balance',
  在途资金余额: 'In-transit funds balance',
  账簿余额: 'Account book balance',
  全部场地: 'All sites',
  互联互通场地: 'Interoperable sites',
  渠道场地: 'Channel sites',
  自营场地: 'Self-operated sites',
  运行中场地: 'Running sites',
  禁用中场地: 'Disabled sites',
  负责人: 'Manager',
  负责人电话: 'Manager phone',
  子设备总数: 'Total number of sub-devices',
  总交易额: 'Total transaction amount',
  标签: 'Tag',
  '道闸减免时间(分)': 'Gate reduction time (min)',
  是否移动端可见: 'Is mobile visible',
  是否推荐: 'Is recommended',
  是否互联互通: 'Is interoperable',
  是否收占位费: 'Is charged for parking',
  场地主图: 'Site main image',
  待处理工单数: 'Pending work order number',
  待回复评论数: 'Pending comment number',
  全部设备: 'All devices',
  正常设备: 'Normal devices',
  库存设备: 'Stock devices',
  故障设备: 'Faulty devices',
  设备编号: 'Device number',
  所属场地: 'Belonging site',
  更多: 'More',
  在线状态: 'Online status',
  设备类型: 'Device type',
  设备品牌: 'Device brand',
  设备型号: 'Device model',
  版本号: 'Version number',
  设备编号: 'Device number',
  二维码: 'QR code',
  所属场地: 'Belonging site',
  在线状态: 'Online status',
  设备状态: 'Device status',
  设备类型: 'Device type',
  批量新增: 'Batch addition',
  新增: 'Add',
  批量删除: 'Batch deletion',
  下载二维码: 'Download QR code',
  批量绑定场地: 'Batch bind site',
  批量绑定代理商: 'Batch bind agent',
  从机数量: 'Number of slaves',
  总销售额: 'Total sales',
  收费模版: 'Charge template',
  最后上报时间: 'Last report time',
  最近上线时间: 'Latest online time',
  报警数: 'Alarm number',
  已处理报警数: 'Processed alarm number',
  全部订单: 'All orders',
  进行中订单: 'In-progress orders',
  已完成订单: 'Completed orders',
  售后订单: 'After-sales orders',
  订单编号: 'Order number',
  用户账号: 'User account',
  终端号: 'Terminal number',
  订单来源: 'Order source',
  支付方式: 'Payment method',
  支付单号: 'Payment number',
  本页数据汇总: 'Data summary on this page',
  支付金额: 'Payment amount',
  订单总额: 'Order total',
  充电量: 'Charging volume',
  订单状态: 'Order status',
  订单结束原因: 'Order end reason',
  订单金额: 'Order amount',
  结束时间: 'End time',
  提现列表: 'Withdrawal list',
  已审核列表: 'Reviewed list',
  提现编号: 'Withdrawal number',
  提现方式: 'Withdrawal method',
  银行卡号: 'Bank account number',
  账号信息: 'Account information',
  持卡人姓名: 'Cardholder name',
  银行名称: 'Bank name',
  开户行: 'Bank',
  提现金额: 'Withdrawal amount',
  提现状态: 'Withdrawal status',
  发起时间: 'Start time',
  转账时间: 'Transfer time',
  已提现总额: 'Withdrawn total amount',
  登录地址: 'Login address',
  登录状态: 'Login status',
  成功: 'Success',
  失败: 'Failure',
  访问编号: 'Visit number',
  用户名称: 'User name',
  登录地址: 'Login address',
  登录地点: 'Login location',
  浏览器: 'Browser',
  操作系统: 'Operating system',
  登录信息: 'Login information',
  登录时间: 'Login time',
  用户昵称: 'User nickname',
  角色: 'Role',
  最后登录IP: 'Last login IP',
  重置密码: 'Reset password',
  删除: 'Delete',
  监控: 'Monitor',
  工单: 'Work order',
  用户: 'User',
  收费: 'Charge',
  曝光量: 'Impression',
  转化率: 'Conversion rate',
  复购率: 'Repeat purchase rate',
  使用率: 'Usage rate',
  点击率: 'Click-through rate',
  '省/市/区': 'Province/City/Area',
  详细地址: 'Detailed address',
  地图坐标: 'Map coordinates',
  负责人: 'Manager',
  分润比例: 'Profit ratio',
  运营商: 'Operator',
  收费方式: 'Charge method',
  占位费设置: 'Parking fee setting',
  停车缓冲时长: 'Parking buffer time',
  超时计费: 'Timeout billing',
  单笔扣费上限: 'Single charge limit',
  分钟: 'minutes',
  从机数: 'Number of slaves',
  '暂无数据，请添加': 'No data, please add',
  综合评分: 'Overall rating',
  评价内容: 'Evaluation content',
  评价图片: 'Evaluation image',
  处理人: 'Handler',
  回复内容: 'Reply content',
  回复图片: 'Reply image',
  处理时间: 'Processing time',
  待处理: 'Pending',
  已完成: 'Completed',
  好评数: 'Good ratings',
  差评数: 'Bad ratings',
  综合评分: 'Overall rating',
  评价内容: 'Evaluation content',
  评价图片: 'Evaluation image',
  处理人: 'Handler',
  回复内容: 'Reply content',
  回复图片: 'Reply image',
  处理时间: 'Processing time',
  待处理: 'Pending',
  已完成: 'Completed',
  工单编号: 'Work order number',
  问题描述: 'Problem description',
  问题图片: 'Problem image',
  工单类型: 'Work order type',
  工单状态: 'Work order status',
  创建人: 'Creator',
  处理图片: 'Processing image',
  处理结果: 'Processing result',
  完成时间: 'Completion time',
  收益人名单: 'Income person list',
  收益比例: 'Income ratio',
  总服务费: 'Total service fee',
  总电费: 'Total electricity bill',
  权限用户: 'Permission user',
  生效时间: 'Effective time',
  截至时间: 'End time',
  总使用次数: 'Total number of uses',
  维护人: 'Maintenance person',
  保存: 'Save',
  请先在设备列表中绑定该场地信息: 'Please bind the site information first in the device list',
  模版名称: 'Template name',
  预付金额: 'Advance payment',
  最大预付金额: 'Maximum advance payment',
  显示单位: 'Display unit',
  总封顶金额: 'Total cap amount',
  保险费用: 'Insurance fee',
  保险说明: 'Insurance description',
  计费周期: 'Billing cycle',
  计费周期单位: 'Billing cycle unit',
  计费周期封顶价: 'Billing cycle cap price',
  备注: 'Remark',
  按时长间隔: 'By time interval',
  收费类型: 'Charge type',
  计费单位: 'Billing unit',
  免费时长: 'Free time',
  免费单位: 'Free unit',
  上限时长: 'Upper limit time',
  价格: 'Price',
  按时刻区间: 'By time interval',
  按使用量: 'By usage',
  '按功率/流量/变化率': 'By power/flow/rate',
  待审核场地: 'Pending site',
  审核通过场地: 'Approved site',
  审核拒绝场地: 'Rejected site',
  新增场地: 'New site',
  场地地址: 'Site address',
  上级代理商: 'Upper-level agent',
  场地主页: 'Site homepage',
  审核说明: 'Audit description',
  场地标签: 'Site tag',
  设置场地标签: 'Set site tag',
  添加标签: 'Add tag',
  服务设施: 'Service facilities',
  '设置服务设施Tag（请上传像素50*50格式为png、jpg图标）':
    'Set service facilities Tag (please upload pixel 50*50 format png/jpg icon)',
  看板: 'Dashboard',
  信息概览: 'Overview',
  小时: 'hour',
  进行中的订单: 'In-progress orders',
  今日订单数: "Today's order number",
  今日销售额: "Today's sales",
  总计订单数: 'Total order number',
  运行时间: 'Running time',
  总耗电量: 'Total power consumption',
  设备信息: 'Device information',
  设备详情: 'Device details',
  所属模板: 'Belonging template',
  最近离线时间: 'Latest offline time',
  离线: 'Offline',
  在线: 'Online',
  操作记录: 'Operation record',
  报警记录: 'Alarm record',
  加载更多: 'Load more',
  子设备: 'Sub-device',
  报警: 'Alarm',
  收益: 'Income',
  调试: 'Debug',
  节点号: 'Node number',
  码: 'Code',
  设备地址: 'Device address',
  节点状态: 'Node status',
  枪状态: 'Gun status',
  状态: 'Status',
  枪是否归位: 'Is the gun in place?',
  是否插枪: 'Is the gun plugged in?',
  输出电压: 'Output voltage',
  输出电流: 'Output current',
  枪线温度: 'Gun wire temperature',
  枪线编码: 'Gun wire code',
  电池组最高温度: 'Battery group highest temperature',
  累计充电时间: 'Cumulative charging time',
  剩余时间: 'Remaining time',
  充电度数: 'Charging degree',
  计损充电度数: 'Damaged charging degree',
  已充金额: 'Charged amount',
  硬件故障: 'Hardware fault',
  交易流水号: 'Transaction number',
  触发器名称: 'Trigger name',
  触发属性名称: 'Trigger attribute name',
  处理状态: 'Processing status',
  报警时间: 'Alarm time',
  触发器类型: 'Trigger type',
  触发条件: 'Trigger condition',
  报警触发值: 'Alarm trigger value',
  '设备名称/用户昵称': 'Device name/user nickname',
  '设备编号/用户手机号': 'Device number/user phone number',
  更新状态: 'Update status',
  更新时间: 'Update time',
  下发时间: 'Issuance time',
  待更新: 'Pending update',
  更新成功: 'Update successful',
  更新失败: 'Update failed',
  搜索: 'Search',
  总成交笔数: 'Total number of transactions',
  总收益变化曲线图: 'Total income change curve',
  列信息: 'Column information',
  操作人员: 'Operator',
  操作人员昵称: 'Operator nickname',
  操作时间: 'Operation time',
  操作类型: 'Operation type',
  IP地址: 'IP address',
  数据日志: 'Data log',
  清屏: 'Clear screen',
  暂停: 'Pause',
  复位计数: 'Reset count',
  发送: 'Send',
  时间范围: 'Time range',
  总充电量: 'Total charging volume',
  充电时长: 'Charging duration',
  电费: 'Electricity bill',
  订单总金额: 'Total order amount',
  用户实付金额: 'Actual payment amount',
  统计时间: 'Statistics time',
  父设备名称: 'Parent device name',
  父设备数量: 'Parent device number',
  使用次数: 'Number of uses',
  使用时长: 'Use duration',
  实付金额: 'Actual payment amount',
  投运时间: 'Installation time',
  取消: 'Cancel',
  确定: 'Confirm',
  运营商名称: 'Operator name',
  活跃用户: 'Active users',
  同步时间: 'Synchronization time',
  枪号: 'Gun number',
  订单信息: 'Order information',
  用户信息: 'User information',
  收费规则: 'Charge rules',
  用户头像: 'User avatar',
  订单号: 'Order number',
  外部订单号: 'External order number',
  开始时间: 'Start time',
  不分退款: 'No refund',
  请输入退款金额: 'Please enter the refund amount',
  确认退款: 'Confirm refund',
  收费规则: 'Charge rules',
  模板名称: 'Template name',
  规则明细: 'Rule details',
  收费信息: 'Charge information',
  平值电量: 'Flat value',
  尖值电量: 'Peak value',
  平值金额: 'Flat value amount',
  尖值金额: 'Peak value amount',
  峰值电量: 'Peak value',
  谷值电量: 'Valley value',
  峰值金额: 'Peak value amount',
  谷值金额: 'Valley value amount',
  场地信息: 'Site information',
  联系方式: 'Contact information',
  地址: 'Address',
  发票信息: 'Invoice information',
  是否已开票: 'Has been invoiced?',
  开票信息需要去开票记录中查看: 'Invoice information needs to be viewed in the invoice record',
  '进行中的订单不可退款，退单金额不能超过订单金额':
    'In-progress orders cannot be refunded, and the refund amount cannot exceed the order amount',
  支付信息: 'Payment information',
  订单分润: 'Order profit',
  订单轨迹: 'Order track',
  订单历史: 'Order history',
  售后信息: 'After-sales information',
  支付来源: 'Payment source',
  支付状态: 'Payment status',
  支付时间: 'Payment time',
  优惠金额: 'Discount amount',
  押金信息: 'Deposit information',
  押金金额: 'Deposit amount',
  押金退款状态: 'Deposit refund status',
  保险信息: 'Insurance information',
  保险金额: 'Insurance amount',
  退款信息: 'Refund information',
  支付退款状态: 'Payment refund status',
  订单退款金额: 'Order refund amount',
  平台分润: 'Platform profit',
  分润金额: 'Profit amount',
  订单结束时间: 'Order end time',
  分润时间: 'Profit time',
  一级代理商: 'Level 1 agent',
  二级代理商: 'Level 2 agent',
  三级代理商: 'Level 3 agent',
  场地: 'Site',
  金额: 'Amount',
  创建订单: 'Create order',
  时间: 'Time',
  操作人: 'Operator',
  设备启动: 'Device start',
  订单结束: 'Order end',
  充电金额: 'Charging amount',
  电池组温度: 'Battery group temperature',
  全部审核列表: 'All audit list',
  待审核列表: 'Pending audit list',
  已审核数: 'Approved number',
  待审核数: 'Pending number',
  请选择: 'Please select',
  提现窗口期设置: 'Withdrawal window setting',
  验证密码: 'Verify password',
  需要: 'Need',
  不需要: 'No need',
  提现开始日: 'Withdrawal start day',
  提现结束日: 'Withdrawal end day',
  '最少提额(日)': 'Minimum withdrawal amount (day)',
  '最大提额(日)': 'Maximum withdrawal amount (day)',
  日: 'day',
  提现手续费: 'Withdrawal fee',
  提现描述: 'Withdrawal description',
  套餐设置: 'Package setting',
  充值记录: 'Recharge record',
  套餐名称: 'Package name',
  充值金额: 'Recharge amount',
  未开发票: 'Not invoiced',
  待审核发票: 'Pending invoice',
  已开发票: 'Invoiced',
  用户手机号: 'User phone number',
  订单类型: 'Order type',
  主设备编号: 'Main device number',
  子设备编号: 'Sub-device number',
  订单类型: 'Order type',
  订单归还时间: 'Order return time',
  手动开票: 'Manual invoice',
  待开发票数量: 'Pending invoice number',
  图片上传: 'Image upload',
  确认: 'Confirm',
  发票类型: 'Invoice type',
  电子邮箱: 'Email',
  审核状态: 'Audit status',
  发票抬头: 'Invoice title',
  接收电话: 'Receive phone',
  税务登记号: 'Tax registration number',
  已开发票数量: 'Invoiced number',
  已开发票金额: 'Invoiced amount',
  开户账号: 'Account number',
  发票金额: 'Invoice amount',
  开票时间: 'Invoice time',
  审核状态: 'Audit status',
  审核: 'Audit',
  关联订单: 'Related order',
  开户行账号: 'Bank account number',
  下载地址: 'Download address',
  提交时间: 'Submit time',
  手续费: 'Fee',
  支付手续费率: 'Payment fee rate',
  场地售卖比例: 'Site selling ratio',
  场地租赁比例: 'Site rental ratio',
  一级合作商名称: 'Level 1 partner name',
  一级合作商租赁比例: 'Level 1 partner rental ratio',
  一级合作商剩余金额: 'Level 1 partner remaining amount',
  平台分润金额: 'Platform profit amount',
  商家分润金额: 'Merchant profit amount',
  二级合作商名称: 'Level 2 partner name',
  二级合作商租赁比例: 'Level 2 partner rental ratio',
  二级合作商分润金额: 'Level 2 partner profit amount',
  三级合作商名称: 'Level 3 partner name',
  三级合作商租赁比例: 'Level 3 partner rental ratio',
  三级合作商分润金额: 'Level 3 partner profit amount',
  结算时间: 'Settlement time',
  场地方: 'Site',
  实时订单: 'Real-time order',
  历史订单: 'Historical order',
  占用订单号: 'Occupied order number',
  占用设备编码: 'Occupied device code',
  最大金额: 'Maximum amount',
  占用费用: 'Occupation fee',
  占用开始时间: 'Occupation start time',
  占用结束时间: 'Occupation end time',
  '占用时长（分）': 'Occupation duration (min)',
  超时计费方式: 'Timeout billing method',
  分: 'min',
  占用时间范围: 'Occupation time range',
  '停车缓冲时长（分）': 'Parking buffer time (min)',
  流水来自: 'Flow from',
  退款: 'Refund',
  人工: 'Manual',
  流水类型: 'Flow type',
  流水号: 'Flow number',
  流水金额: 'Flow amount',
  优惠券名称: 'Coupon name',
  待使用: 'Pending use',
  优惠券列表: 'Coupon list',
  已使用: 'Used',
  已失效: 'Expired',
  优惠券性质: 'Coupon nature',
  优惠券状态: 'Coupon status',
  优惠券图片: 'Coupon image',
  优惠券说明: 'Coupon description',
  优惠券类型: 'Coupon type',
  库存: 'Inventory',
  上架: 'Shelve',
  下架: 'Unshelve',
  优惠券信息: 'Coupon information',
  领取时间: 'Claim time',
  领取时间范围: 'Claim time range',
  任务名称: 'Task name',
  任务状态: 'Task status',
  执行模式: 'Execution mode',
  执行时间: 'Execution time',
  终止原因: 'Termination reason',
  终止: 'Terminate',
  发放用户: 'Issued user',
  立即执行: 'Execute immediately',
  定时执行: 'Timed execution',
  执行记录: 'Execution record',
  使用时间: 'Use time',
  收费模板列表: 'Charge template list',
  模板使用列表: 'Template usage list',
  收费模式: 'Charge mode',
  模板类型: 'Template type',
  模板明细: 'Template details',
  版本: 'Version',
  更新人: 'Updater',
  预付最大金额: 'Maximum advance payment',
  年: 'year',
  季: 'season',
  月: 'month',
  时: 'hour',
  周: 'week',
  度: 'degree',
  单价: 'Price',
  上限: 'Upper limit',
  瓦: 'W',
  时长: 'Duration',
  梯度: 'Gradient',
  时刻: 'Moment',
  尖峰平谷: 'Peak off-peak valley',
  区间时长: 'Interval duration',
  开始: 'Start',
  至: 'To',
  模板总数: 'Total number of templates',
  广告名称: 'Advertisement name',
  广告类型: 'Advertisement type',
  文件类型: 'File type',
  上下架: 'Shelve/unshelve',
  文件: 'File',
  播放次数: 'Play count',
  修改: 'Modify',
  广告总数: 'Total number of advertisements',
  播放总数: 'Total number of plays',
  图片: 'Image',
  视频: 'Video',
  广告内容: 'Advertisement content',
  是否跳转: 'Is redirect',
  否: 'No',
  选跳转url: 'Select redirect URL',
  跳转富文本: 'Redirect rich text',
  '开始时间/结束时间': 'Start time/end time',
  跳转内容: 'Redirect content',
  跳转url地址: 'Redirect URL address',
  招商配置: 'Marketing configuration',
  加盟角色: 'Join role',
  预算: 'Budget',
  是否联系: 'Is contact',
  用户姓名: 'User name',
  回访人员: 'Return visitor',
  回访时间: 'Return visit time',
  申请总数: 'Total number of applications',
  意向总数: 'Total number of intentions',
  code唯一标识: 'Code unique identifier',
  标题名: 'Title name',
  用户协议: 'User agreement',
  隐私政策: 'Privacy policy',
  维护记录: 'Maintenance record',
  平台: 'Platform',
  用户端: 'User end',
  代理端: 'Agent end',
  语言类型: 'Language type',
  中文: 'Chinese',
  英文: 'English',
  维护类型: 'Maintenance type',
  语言: 'Language',
  内容: 'Content',
  问题标题: 'Issue title',
  分类名称: 'Category name',
  简述: 'Brief',
  开关: 'Switch',
  微信客服: 'WeChat customer service',
  微信客服配置: 'WeChat customer service configuration',
  电话: 'Phone',
  电话配置: 'Phone configuration',
  留言: 'Message',
  文章类型: 'Article type',
  文章列表: 'Article list',
  排序: 'Sort',
  查看文章: 'View article',
  标题: 'Title',
  图文封面: 'Picture and text cover',
  作者: 'Author',
  浏览量: 'Views',
  收藏数: 'Collects',
  评论数: 'Comments',
  文章内容: 'Article content',
  文章详情: 'Article details',
  文章标题: 'Article title',
  文章分类: 'Article category',
  文章作者: 'Article author',
  未使用总数: 'Unused total number',
  创建日期范围: 'Creation date range',
  通知列表: 'Notification list',
  消息标题: 'Message title',
  消息类型: 'Message type',
  发送用户: 'Send user',
  点赞数: 'Likes',
  已读数: 'Read count',
  品牌名: 'Brand name',
  系列名称: 'Series name',
  文本: 'Text',
  工单总数: 'Total number of work orders',
  处理中: 'In progress',
  处理: 'Processing',
  处理完成: 'Processing complete',
  处理内容: 'Processing content',
  反馈类型: 'Feedback type',
  反馈内容: 'Feedback content',
  反馈图片: 'Feedback image',
  总数: 'Total',
  处理总数: 'Total number of processes',
  未处理总数: 'Total number of unprocessed',
  类型名称: 'Type name',
  父级名称: 'Parent name',
  父级类型: 'Parent type',
  品牌名称: 'Brand name',
  编辑品牌: 'Edit brand',
  电桩品牌: 'Plug brand',
  电桩型号: 'Plug model',
  电桩类型: 'Plug type',
  充电枪数量: 'Charging gun number',
  '电桩功率(kW)': 'Plug power (kW)',
  '温馨提示：只能上传jpg/jpeg/pngFile，且不超过2M':
    'Tip: Only jpg/jpeg/png files can be uploaded, and the size cannot exceed 2M',
  设备图片: 'Device image',
  备注说明: 'Remark',
  辅助电源: 'Auxiliary power',
  兼容12V和24V: 'Compatible with 12V and 24V',
  输入电压: 'Input voltage',
  最大电压: 'Maximum voltage',
  最小电压: 'Minimum voltage',
  最大电流: 'Maximum current',
  最小电流: 'Minimum current',
  枪线温度预警: 'Gun wire temperature warning',
  枪线温度断充: 'Gun wire temperature dis-charge',
  恒功率输出电压区间: 'Constant power output voltage range',
  请输入枪线温度预警: 'Please enter the gun wire temperature warning',
  请输入枪线温度断充: 'Please enter the gun wire temperature dis-charge',
  '时间(分钟)': 'Time (minutes)',
  小程序卡: 'Mini program card',
  企业用户: 'Enterprise user',
  非企业用户: 'Non-enterprise user',
  '${status==1 ?\"禁用\":\"启用\"}':'${status==1 ?\"Disabled\":\"Enabled\"}',
  '确定要${status==1?\"禁用\":\"启用\"}该用户吗？':'Are you sure to ${status==1?"Disabled":"Enabled"} this user?',
  '${status==1?"禁用":"启用"}':'${status==1?"Disabled":"Enabled"}',
  '确定要${status==1?"禁用":"启用"}该用户吗？':'Are you sure to ${status==1?"Disabled":"Enabled"} this user?',
  '数据删除后无法恢复，请确认!':'Data cannot be restored after deletion, please confirm!',
  '确定要${siteStatus==1?"禁用":"启用"}该场地吗？':'Are you sure to ${siteStatus==1?"Disabled":"Enabled"} this site?',
  '场地详情图': 'Site detail image',
  '是否收取占用费': 'Is the occupation fee charged',
  '是': 'Yes',
  '占用收费设置（充电完成规定时间未拔枪）': 'Occupation Charge setting (charging completed within the specified time)',
  '示例：设置扣费上限为10元，单笔占用订单计费为20元时，仅收取用户10元费用': 'Example: Set the upper limit of deduction to 10 yuan, and charge the user 10 yuan for a single occupancy order when the charging fee is 20 yuan, only charge the user 10 yuan',
  '设置占用订单最大扣费金额': 'Set the maximum deduction amount for the occupation order',
  '请输入预留给用户充完电拔枪离场时长': 'Please enter the time reserved for the user to unplug the gun after charging',
  '设置服务设施标签': 'Set service facility labels',
  '（请上传像素50*50格式为png、jpg图标）': '(Please upload pixel 50*50 format png/jpg icon)',
  '枪数量': 'Number of guns',
  '功率': 'Power',
  '电压': 'Voltage',
  设备编号前缀: 'Device number prefix',
  设备名称前缀: 'Device name prefix',
  设备编号值: 'Device number value',
  绑定代理商: 'Bind agent',
  绑定场地: 'Bind site',
  '确定要批量删除数据?': 'Are you sure to delete the data in batches?',
  数量: 'Number',
  设备编号开始值: 'Device number start value',
  编号递增因子: 'Number increment factor',
  '例开始值1递增因子2.编号就是1，3，5': 'Example start value 1 increment factor 2. The number is 1, 3, 5',
  '使用时长（小时）': 'Usage duration (hour)',
  '通过': 'Through',
  '拒绝': 'Reject',
  优惠券库存: 'Coupon inventory',
  优惠券剩余库存: 'Remaining coupon inventory',
  请输入任务名称: 'Please enter the task name',
  优惠性质: 'Discount nature',
  满减: 'Full reduction',
  折扣: 'Discount',
  是否手动下发: 'Is it manually issued',
  开始结束时间: 'Start and end time',
  发布数量: 'Release quantity',
  '-1表示无数量限制': '-1 means no quantity limit',
  选项: 'Option',
  招商模板名称: 'Marketing template name',
  跳转地址: 'Redirect address',
  终端类型: 'Terminal type',
  消息简述: 'Message brief',
  消息图片: 'Message image',
  消息终端: 'Message terminal',
  指定类型: 'Designated type',
  消息内容: 'Message content',
  全部: 'All',
  指定用户: 'Designated user',
  指定代理商: 'Designated agent',
  小程序: 'Mini Program',
  公众号: 'Public account',
  系统消息: 'System message',
  活动消息: 'Activity message',
  新增品牌: 'Add brand',
  请输入品牌名称: 'Please enter the brand name',
  请输入备注:'Please enter remarks:',
  请输入电桩型号: 'Please enter the plug model',
  请输入充电枪数量: 'Please enter the number of charging guns',
  '温馨提示：只能上传jpg/jpeg/png文件，且不超过2M': 'Tip: Only jpg/jpeg/png files can be uploaded, and the size cannot exceed 2M',
  '请输入电桩功率(kW)': 'Please enter the plug power (kW)',
  请输入最大电压: 'Please enter the maximum voltage',
  请输入最小电压: 'Please enter the minimum voltage',
  请输入最大电流: 'Please enter the maximum current',
  请输入最小电流: 'Please enter the minimum current',
  电压下限: 'Voltage lower limit',
  电压上限: 'Voltage upper limit',
  导入: 'Import',
  IC卡号: 'IC card number',
  用户余额: 'User balance',
  卡状态: 'Card status',
  激活时间: 'Activation time',
  禁用时间: 'Disable time',
  废弃时间: 'Discard time',
  待激活: 'Pending activation',
  废弃: 'Discarded',
  文件上传: 'File upload',
  模板下载: 'Template download',

}
